// eslint-disable-next-line import/prefer-default-export
export const MAY_2025 = new Date("2025-05-30");
